import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import {
  area_bg,
  area_covered,
  home_page_single_search,
  template1Banner,
  washFoldBg,
} from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { RootState } from '@/core/redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';

const BannerEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>(themeData);
  const [images, setImages] = useState<Array<string>>([]);
  const [cropImageHeight, setCropImageHeight] = useState('150');
  const [cropImageWidth, setCropImageWidth] = useState('400');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const handleHeaderChange = (e: any) => {
    const { value, name } = e.target;
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_1: {
            ...prevJsonData.theme_1.home.section_1,
            [name]: value,
            btn_group: {
              ...prevJsonData?.theme_1?.home.section_1.btn_group,
              btn1: {
                ...prevJsonData?.theme_1?.home.section_1.btn_group.btn1,
                [name]: value,
              },
            },
          },
        },
      },
    }));
  };
  const saveJsonData = async () => {
    console.log('entered');
    
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    if (image.type.startsWith('image/')) {
      // setSelectedCropImage(image);
      // setShowCropModal(true);
      setBannerType('image');
      if (image instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (res: any) => {
          handleCroppedImage(res.target.result);
        };
      }
    } else if (image.type.startsWith('video/')) {
      // handleCroppedImage(image);
      setBannerType('video');
      if (image instanceof File) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = (res: any) => {
          handleCroppedImage(res.target.result);
        };
      }
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };
  const handleImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_1: {
            ...prevJsonData.theme_1.home.section_1,
            banner: image,
          },
        },
      },
    }));
  };

  const setBannerType = (type: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_1: {
            ...prevJsonData.theme_1.home.section_1,
            banner_type: type,
          },
        },
      },
    }));
  };
  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  // Update Redux store when themeData template_images changes
  // useEffect(() => {
    // if (themeData?.template_images && typeof themeData.template_images === 'object') {
    //   dispatch(setTemplateImages(themeData.template_images));
    // }
  // }, [themeData, dispatch]);

  // Load existing template images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      // Get the current template (template1, template2, etc.)
      const templateKey = template ? `template${template}` : 'template1';
      
      // Extract banner images for the current template
      const currentTemplate = templateImages[templateKey];
      const bannerImages = currentTemplate?.banner || [];
      
      if (Array.isArray(bannerImages) && bannerImages.length > 0) {
        // Filter images by resolution - for banner, show wide/banner resolutions (aspect ratio > 1.3)
        const filteredImages = bannerImages.filter((img: any) => {
          if (!img.resolution) return true; // Include images without resolution info
          
          const [width, height] = img.resolution.split('x').map(Number);
          const aspectRatio = width / height;
          
          // Filter for banner/wide images (aspect ratio > 1.3, typically banners like 1792x1024)
          return aspectRatio > 1.3;
        });
        
        // Extract URLs from the filtered image objects
        const imageUrls = filteredImages.map((img: any) => img.url);
        setImages(imageUrls);
      } else {
        setImages([]);
      }
    } else {
      setImages([]);
    }
  }, [templateImages, template]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Auto-generate prompt based on banner context
  const generateAutoPrompt = (): string => {
    // Get context from the current banner data
    const title = editData?.theme_1?.home?.section_1?.title || '';
    const subHeading = editData?.theme_1?.home?.section_1?.sub_heading_top || '';
    const paragraph = editData?.theme_1?.home?.section_1?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional banner image for website hero section';
    
    if (title || subHeading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        // Extract keywords from paragraph
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add banner-specific styling
    contextPrompt += ', clean modern aesthetic, professional photography, wide format suitable for hero banner, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleImageChange(imageUrl);
    setBannerType('image');
    
    // Add to images array for slider
    setImages(prevImages => [...prevImages, imageUrl]);
  };

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section One Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="mb-3">
              <label className="form-label">
                Sub Title <small>(max 250 char)</small>
              </label>
              <input
                type="text"
                className="form-control"
                name="sub_heading_top"
                value={editData?.theme_1?.home?.section_1?.sub_heading_top}
                onChange={handleHeaderChange}
                maxLength={250}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">
                Title<small>(max 250 char)</small>
              </label>
              <input
                type="text"
                className="form-control"
                name="title"
                onChange={handleHeaderChange}
                value={editData?.theme_1?.home?.section_1?.title}
                maxLength={250}
              />
              <div className="mt-2">
                <label className="form-label small">Title Color</label>
                <div className="input-group color-change">
                  <input
                    type="text"
                    className="form-control"
                    name="title_color"
                    value={
                      editData?.theme_1?.home?.section_1?.title_color || '000000'
                    }
                    onChange={handleHeaderChange}
                  />
                  <ColorPicker
                    name="title_color"
                    format="hex"
                    onChange={handleHeaderChange}
                    value={
                      editData?.theme_1?.home?.section_1?.title_color || '000000'
                    }
                  />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                <label className="form-label mb-0 mr-2">
                  Description
                </label>
                <AIContentWriter
                  onContentGenerated={(content) => {
                    handleHeaderChange({
                      target: {
                        name: 'paragraph',
                        value: content,
                      },
                    });
                  }}
                  contentType="hero_section"
                  placeholder="Describe what you want in your banner description. Example: 'Write about our fast delivery service, 24/7 support, and wide product selection'"
                  context="This is for a website hero banner section description"
                />
              </div>
              <textarea
                className="form-control"
                name="paragraph"
                onChange={handleHeaderChange}
                value={editData?.theme_1?.home?.section_1?.paragraph}
                maxLength={1200}
                rows={3}
              />
              <div className="mt-2">
                <label className="form-label small">Description Color</label>
                <div className="input-group color-change">
                  <input
                    type="text"
                    className="form-control"
                    name="paragraph_color"
                    value={
                      editData?.theme_1?.home?.section_1?.paragraph_color || '000000'
                    }
                    onChange={handleHeaderChange}
                  />
                  <ColorPicker
                    name="paragraph_color"
                    format="hex"
                    onChange={handleHeaderChange}
                    value={
                      editData?.theme_1?.home?.section_1?.paragraph_color || '000000'
                    }
                  />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <div className="row">
                <div className="col-md-12">
                  <div className="img-bg active">
                    {editData?.theme_1?.home?.section_1?.banner_type ==
                    'image' ? (
                      <img
                        src={editData?.theme_1?.home?.section_1?.banner}
                        alt="Hero Image"
                        className="img-fluid"
                      />
                    ) : (
                      <>
                        <video
                          loop
                          autoPlay
                          className="img-fluid"
                          src={editData?.theme_1?.home?.section_1?.banner}
                        ></video>
                      </>
                    )}
                  </div>
                  <div className="img-options">
                    <div className="row">
                      <div className="col-md-12">
                        {images.length > 0 ? (
                          <Swiper
                            spaceBetween={15}
                            navigation={true}
                            modules={[Navigation]}
                            breakpoints={{
                              640: {
                                slidesPerView: 1,
                              },
                              768: {
                                slidesPerView: 4,
                              },
                              1024: {
                                slidesPerView: 6,
                              },
                            }}
                            className="homejson-slider"
                          >
                            {images.map((images: string, index: any) => {
                              return (
                                <>
                                  <SwiperSlide>
                                    <div
                                      className="img-option"
                                      key={index}
                                      onClick={() => {
                                        handleImageChange(images);
                                        setBannerType('image');
                                      }}
                                    >
                                      <img
                                        src={images}
                                        alt="Hero Image"
                                        className="img-fluid"
                                      />
                                    </div>
                                  </SwiperSlide>
                                </>
                              );
                            })}
                          </Swiper>
                        ) : (
                          <div className="empty-slider-state text-center py-4">
                            <div className="empty-state-content">
                              <i className="fas fa-images fa-3x text-muted mb-3"></i>
                              <h6 className="text-muted mb-2">No Images Available</h6>
                              <p className="text-muted small mb-3">
                                Generate AI images or upload your own to see them here
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <AIImageGenerator
              generateAutoPrompt={generateAutoPrompt}
              onSave={handleAIImageSave}
              imageType="banner"
              defaultWidth="1792"
              defaultHeight="1024"
              title="AI Image"
              autoGenerate={true}
              template={template}
            />
            <div className="mb-3">
              <label className="form-label">Upload Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                name="image"
                onChange={updateImageSectionOne}
              />
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button</label>
                    <input
                      type="text"
                      className="form-control"
                      name="text"
                      value={
                        editData?.theme_1?.home?.section_1?.btn_group?.btn1
                          ?.text
                      }
                      onChange={handleHeaderChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Background</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editData?.theme_1?.home?.section_1?.btn_group?.btn1
                            ?.bg_color
                        }
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="bg_color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={
                          editData?.theme_1?.home?.section_1?.btn_group?.btn1
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editData?.theme_1?.home?.section_1?.btn_group?.btn1
                            ?.color
                        }
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={
                          editData?.theme_1?.home?.section_1?.btn_group?.btn1
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Placeholder</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="placeholder"
                        value={
                          editData?.theme_1?.home?.section_1?.btn_group?.btn1
                            ?.placeholder
                        }
                        maxLength={250}
                        onChange={handleHeaderChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default BannerEditModal;
